module.exports = __webpack_public_path__ + "img/Image 90@2x.623e77bb.png";